export default "/images/tooth_brushing_sm.jpg?dcf9343f43c53e4b977962da06b1a391";